exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-before-discount[data-v-07206ca8] {\n  text-decoration: line-through;\n}\n.price > div[data-v-07206ca8] {\n  display: -ms-flexbox;\n  display: flex;\n  row-gap: 4px;\n  -webkit-column-gap: 16px;\n     -moz-column-gap: 16px;\n          column-gap: 16px;\n}\n", ""]);

// exports
